// extracted by mini-css-extract-plugin
module.exports = {"slide_out":"MobileNavigation-module__5gjvZW__slide_out","slide_in":"MobileNavigation-module__5gjvZW__slide_in","main":"MobileNavigation-module__5gjvZW__main"};